import config from 'config'

export const isMultiVendor = () => config.MULTI_VENDOR_ENABLED === '1'
